import groq from "groq";
import metaFields from "./metaFields";
import { applyFrench } from "@lib/applyFrenchField";

const bundlesCollection = groq`
  *[_id == "bundles-collection"] {
    ${metaFields}
    "title": ${applyFrench("title", "title_fr")},
    "description": ${applyFrench("description", "description_fr")},
    bundles[] {
      ...,
      bundleReference->{
        "title": ${applyFrench("title", "title_fr")},
        slug,
        "discountMessage": ${applyFrench("discountMessage", "discountMessage_fr")},
        "image": images[0]
      }
    }
  }[0]
`;

export default bundlesCollection;
